import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { PRICEMULTIPLIER } from '../../../../../../lib/lib-shared/defines';
import { ICreditDetailsListByUserId } from '../../../../../../lib/lib-shared/models/Credit';
import { IUserCreditEditFormSubmit } from './user-credit-edit-form.component.type';

@Component({
  selector: 'lm-user-credit-edit-form',
  templateUrl: './user-credit-edit-form.component.html',
  styleUrls: ['./user-credit-edit-form.component.scss'],
})
export class UserCreditEditFormComponent implements OnInit {
  @Input() credit: ICreditDetailsListByUserId;

  @Output() submit = new EventEmitter<IUserCreditEditFormSubmit>();
  @Output() cancel = new EventEmitter<void>();

  public form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private ngbDateParserFormatter: NgbDateParserFormatter,
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      endedAt: [this.ngbDateParserFormatter.parse(this.credit.endedAt), Validators.required],
      ...!this.credit.orderCredit && {
        amount: [this.credit.amount / PRICEMULTIPLIER, [Validators.required, Validators.min(0)]],
      },
    });
  }

  save() {
    const amountInBase100 = this.form.controls.amount ? this.form.value.amount * PRICEMULTIPLIER : undefined;
    const endedAt = this.form.value.endedAt ? this.ngbDateParserFormatter.format(this.form.value.endedAt) : undefined;

    this.submit.emit({
      id: this.credit.id,
      ...endedAt !== this.credit.endedAt && {endedAt: endedAt},
      ...amountInBase100 !== undefined && amountInBase100 !== this.credit.amount && {amount: amountInBase100},
    });
  }
}
